import React from "react";
import { motion } from "framer-motion";
import {
  FaFlask,
  FaLaptop,
  FaUserFriends,
  FaChalkboardTeacher,
  FaChild,
  FaSchool,
  FaMedal,
  FaGraduationCap,
  FaRobot,
  FaUsers,
} from "react-icons/fa";

const features = [{
    title: "Small Batch Sizes & Personal Mentoring",
    icon: <FaUserFriends size={50} className="text-purple-500 mb-2" />,
    border: "border-purple-500",
  },{
    title: "Smart Classrooms & Digital Tools",
    icon: <FaLaptop size={50} className="text-orange-500 mb-2" />,
    border: "border-orange-500",
  },
  {
    title: "IIT-JEE & NEET Foundation",
    icon: <FaFlask size={50} className="text-green-600 mb-2" />,
    border: "border-green-600",
  },
  
  
  {
    title: "Leadership & Life Skills Programs",
    icon: <FaChalkboardTeacher size={50} className="text-sky-500 mb-2" />,
    border: "border-sky-500",
  },
  {
    title: "Robotics, Coding & AI Labs",
    icon: <FaRobot size={50} className="text-blue-600 mb-2" />,
    border: "border-blue-600",
  },
  {
    title: "Clubs & Co-Curricular Activities",
    icon: <FaUsers size={50} className="text-purple-600 mb-2" />,
    border: "border-purple-600",
  }
];

const CircleFeatures = () => {
  return (
    <div className=" justify-center gap-8 py-10">
       <h2  className="text-3xl md:text-4xl font-bold text-center text-black">
        Rankridge Provides Outstanding Benefits  
      </h2>
     <div className="flex flex-wrap justify-center py-10">
      {features.map((item, idx) => (
        <motion.div
          key={idx}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: idx * 0.1, duration: 0.4 }}
          style={{marginTop:'-1rem'}}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 20px rgba(0,0,0,0.15)" }}
          className={`w-40 h-40  flex flex-col items-center justify-center text-center p-3  ${item.border} bg-white shadow transition-transform duration-300 overflow-hidden`}
        >
          {item.icon}
          <p className="text-xs font-medium text-black leading-snug">{item.title}</p>
        </motion.div>
      ))}
      </div>
    </div>
  );
};
export default CircleFeatures;
